<template lang="html">
  <div class="info-container py-5">
    <h1 class="h1 text-center text-light text-uppercase">Lorem ipsum dolor sit amet consectetur</h1>
    <h2 class="h1 text-center text-light text-uppercase font-weight-bold">Lorem ipsum</h2>

    <div class="infograph position-relative d-flex align-items-center justify-content-center flex-wrap">
      <div class="left">
        <div class="infograph-item">
          <h1 class="text-light mb-2 text-sm-center text-md-left">Lorem ipsum</h1>
          <p class="text-light">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod.</p>
        </div>
        <div class="infograph-item">
          <h1 class="text-light mb-2 text-sm-center text-md-left">Lorem ipsum</h1>
          <p class="text-light">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod.</p>
        </div>
      </div>
      <div class="middle">
        <div class="infograph-icon"></div>
      </div>
      <div class="right">
        <div class="infograph-item">
          <h1 class="text-light mb-2 text-sm-center text-md-left">Lorem ipsum</h1>
          <p class="text-light">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod.</p>
        </div>
        <div class="infograph-item">
          <h1 class="text-light mb-2 text-sm-center text-md-left">Lorem ipsum</h1>
          <p class="text-light">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
.info-container{
  background: url('/images/sproduct-bg.jpg');
}
.infograph-item{
  color: #FFF;
  background: #2a81ea;
  margin: 2rem auto;
  padding: 2rem .5rem;
  border-radius: 18px;
  font-size: 22px;
  width: 100%;
}
.left, .right{
  position: relative;
  width: 30%;
}
.left .infograph-item{
  padding-right: 3rem ;
  margin-right: -3rem;
}
.right .infograph-item{
  padding-left: 3rem;
  margin-left: -3rem
}
.infograph-icon{
  width: 380px;
  height: 380px;
  border-radius: 50%;
  background: url('/images/products/product_11.jpg');
  background-size: cover;
  background-position: center center;
  box-shadow: 0 0 15px 1px #000;
  position: relative;
  z-index: 5 ;
}
@media(max-width:1157px){
  .infograph-icon{
    width: 280px;
    height: 280px;
  }
}
@media(max-width:970px){
  .right .infograph-item, .left .infograph-item{
    margin: 2rem auto;
    padding: 1rem
  }
  .right, .left, .middle{
    width: 80% !important;
  }
  .middle .infograph-icon{
    margin: auto;
  }
}
</style>
